<template>
  <div class="sidebar">
    <iscroll-view class="scroll-view" :options="{disableTouch: true, momentum: false, mouseWheel: true, scrollbars: true, fadeScrollbars: true, interactiveScrollbars: true, snap: true}" ref="iscroll">
      <div class="sidebar-wrap">
        <OtherFta class="list" :ranks="ranks" :exporterID="exporterID" :importerID="importerID" :hscode="hscode" v-if="!this._.isEmpty(ranks)" />
        <RelatedPolicy class="list" />
        <RelatedNews class="list" />
      </div>
    </iscroll-view>
  </div>
</template>

<script>
import OtherFta from './common/OtherFta'
import RelatedPolicy from './common/RelatedPolicy'
import RelatedNews from './common/RelatedNews'

export default {
  name: 'RulesSider',
  components: { OtherFta, RelatedPolicy, RelatedNews },
  props: {
    ranks: {
      type: Array,
      default: () => [],
      required: false
    },
    exporterID: {
      type: [String, Number]
    },
    importerID: {
      type: [String, Number]
    },
    hscode: {
      type: [String, Number]
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => { this.refresh() }, 500)
    })
  },
  methods: {
    refresh () {
      this.$refs.iscroll && this.$refs.iscroll.refresh()
    }
  }
}
</script>
<style scoped>
  .sidebar{
    overflow: hidden;
  }
  .scroll-view{
    /* -- Attention: This line is extremely important in chrome 55+! -- */
    touch-action: none;
    /* -- Attention-- */
    /*position: fixed;*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
  .sidebar-wrap{
    padding: 20px 18px;
  }
  .list{
    padding: 20px 0;
    border-bottom: 0.5px solid #E9E9E9;
  }
  .list:first-child{
    padding-top: 0;
  }
  .list:last-child{
    border-bottom: 0 none;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/query/RulesSider.vue